$activities = $('.activities')
$activity =  $('.activity')
$activity.hover -> $activities.toggleClass('activity-hovered')
